import * as React from 'react';
import { useCurrentFluent2Theme } from '../../../hooks/styling';
import { FluentIconNames } from '../../common/fluent-icon-names';
import { useSuccessToastContext } from '../hooks/toast-hooks';
import { BaseToast } from './base-toast';

export const SuccessToast: React.FC = React.memo(() => {
    const { isOpen, properties, closeSurface } = useSuccessToastContext();
    const theme = useCurrentFluent2Theme();
    return (
        <BaseToast
            isOpen={isOpen}
            title={properties?.title}
            autoHideDelay={properties?.autoHideDelay}
            devBoxName={properties?.devBoxName}
            iconName={FluentIconNames.Accept}
            backgroundColor={theme.colorNeutralBackground3}
            onDismiss={closeSurface}
        >
            {properties?.children}
        </BaseToast>
    );
});
